import { ObjectState } from "../../containers/centralView/taskListView/types/tasklListViewProps";
import { ConfigField } from "../../contexts/krFormContext";
import { poFormTypes } from "../../contexts/poFormContext";
import { createValidationPoForm, validationErrorsPoForm } from "../../helpers/validation/validation";
import { httpGet, httpPost } from "../httpService/httpService";
import { AddProtocolRastersProps, GetProtocolsProps, SaveProtocolProps, UpdateProtocolStateProps, ValidateSelectedProtocolsProps } from "./types/protocolFormServiceProps";

export const populateProtocolForm = async (waitingRoomGlobalId: string, apiUrl: string, changeStatus: boolean, newStatus?: ObjectState) => {
    if (changeStatus && newStatus) {  
        const formData = new FormData();
        formData.append('WaitingRoomGids', waitingRoomGlobalId);
        formData.append('State', newStatus?.toString());
            
        return new Promise((resolve, reject) => {
            httpPost(apiUrl + `/populate-protocol-form-change-state`, { WaitingRoomGids: JSON.stringify([waitingRoomGlobalId]), State: newStatus?.toString() }).then((data: any) => {
                resolve(data.data as poFormTypes);
            }).catch((error: any) => {
                reject(error);
            });
        });
    }
    else {
        return new Promise((resolve, reject) => {
            httpGet(apiUrl + `/${waitingRoomGlobalId}/populate-protocol-form`).then((data: any) => {
                resolve(data.data as poFormTypes);
            }).catch((error: any) => {
                reject(error);
            });
        });
    }
}

export const saveProtocol = async (props: SaveProtocolProps, validation?: boolean) => {
    const formData = new FormData();

    var clearedForm = structuredClone(props.poForm);

    clearedForm.rasters = clearedForm.rasters?.map(item => {
        if (item.blob !== null) item.blob = null;
        return item;
    })

    let objToSave = Object.assign({}, clearedForm, {
        dicts: undefined,
        config: undefined,
        dictionaries: undefined,
        dictionariesCodedValues: undefined,
        Validation: undefined,
        endangeredAreaGminy: undefined,
        landslideGminy: undefined
    });
    formData.append('PoForm', JSON.stringify(objToSave));
    formData.append('State', props.state ? props.state : "");
    if(validation !== undefined){
        formData.append('ValidationStatus', validation ? "pozytywna" : "negatywna");
    }

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/save-protocol`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const updateProtocolState = async (props: UpdateProtocolStateProps) => {
    const formData = new FormData();
    formData.append('WaitingRoomGids', JSON.stringify(props.waitingRoomGids));
    formData.append('State', props.state);

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/update-protocol-state`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const validateSelectedProtocols = async (props: ValidateSelectedProtocolsProps) => {
    
    let getProtocolsProps: GetProtocolsProps = { 
        waitingRoomGids: props.waitingRoomGids, 
        apiBase: props.apiBase
    }

    return new Promise((resolve, reject) => {
        getProtocolsByWaitingRoomGids(getProtocolsProps)
        .then((response: any) => {
            var valid = true;
            var config: ConfigField = {};
            for (const poForm of response) {
                if (!valid) break;
                if (config.Validation === undefined) {
                    config.Validation = createValidationPoForm(poForm);
                }
                poForm.config = config;
                var form = validationErrorsPoForm(poForm) 
                valid = form.config?.isValid === true;
            }
            resolve(valid);
        })
        .catch((error: any) => {
            reject(error);
        });
    });   
}

export const getProtocolsByWaitingRoomGids = async (props: GetProtocolsProps) => {
    const formData = new FormData();
    formData.append('WaitingRoomGids', JSON.stringify(props.waitingRoomGids));

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/get-protocols`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const addProtocolRasters = async (props: AddProtocolRastersProps) => {
    
    const formData = new FormData();
    formData.append('RastersAttributes', JSON.stringify(props.rastersAttributes));
    formData.append('ObjectIdNumber', props.objectIdNumber.toString());
    formData.append('IsLandslide', props.isLandslide.toString());
    formData.append('WaitingRoomGlobalId', props.waitingRoomGlobalId ? props.waitingRoomGlobalId : "");
    formData.append('FilePath', props.filePath);

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/add-protocol-rasters`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

